import React from "react";
import NewsletterPosts from "../newsletter-posts";
import Footer from "../global/footer";
import Header from "../global/header";

const NewsletterPost = ({ headerv3, footer }) => {
  const { menuv3 } = footer;
  return (
    <>
      <Header header={headerv3} />
      <NewsletterPosts isBg="" />
      <Footer isBg="yes" menu={menuv3} />
    </>
  );
};

export default NewsletterPost;
